import { useState } from 'react';
import Page from '../components/Page/Page';
import { User } from '../models/user';
import { IonCard, useIonRouter } from '@ionic/react';
import SocketTestPage from './user/events/_SocketTestPage';

type Chat = {
  id: string;
  members: User[];
  type: 'private' | 'group' | 'support';
  updatedAt: string;
  lastMessage: string;
};

const initialChats: Chat[] = [
  {
    id: '1',
    members: [],
    type: 'private',
    updatedAt: '20 dec',
    lastMessage: '10 dec',
  },
];

export const MessagesPage: React.FC = () => {
  const [chats, setChats] = useState<Chat[]>([]);

  const router = useIonRouter();

  return <SocketTestPage />;

  //   <Page headerProps={{ title: 'Messages' }}>
  //     <IonCard style={{ margin: '10px' }}>
  //       <p>No new messages</p>
  //     </IonCard>
  //     {/* <p>TODO</p>

  //     <p onClick={() => router.push('/events/messages/<chatID>')}>Chat 1</p>
  //     <p>Chat 2</p>
  //     <p>Chat 3</p> */}
  //   </Page>
};
